export const text = {
  heading1: "font-heading font-semibold text-3xl md:text-4xl text-primary-500",
  heading2: "font-heading font-semibold text-xl md:text-2xl text-primary-500",
  heading3: "font-heading font-semibold text-base md:text-lg text-primary-500",
  body1: "font-body text-base leading-relaxed",
  description1: "font-body text-base text-muted-foreground leading-relaxed",
};

export const link = {
  heading3: `${text.heading3} hover:underline decoration-2 underline-offset-4`,
};

export const input = {
  default: `rounded-md w-80 h-12 p-4 ${text.body1}`,
};

export const button = {
  primary:
    "rounded-md bg-primary-500 active:bg-primary-500/90 justify-center items-center text-center p-3",
  secondary:
    "rounded-md bg-secondary-500 active:bg-secondary-500/90 justify-center items-center text-center p-3",
  text: "font-heading font-semibold text-sm md:text-base text-white text-center uppercase",
};
